import React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import ReactTooltip from 'react-tooltip';
import AppActions from '../../actions/app-actions';

// material ui
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import InfoIcon from '@material-ui/icons/Info';

// import Alert from '../common/alert';
// import CancelRequestDialog from './cancelrequest';
import TenantInfo from './tenant-info';

export default class MyOrganization extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      org: {
        tenant_token: '',
        id: '',
        name: '',
        tenant_info: {}
      },
      copied: false,
      cancelSubscription: false,
      cancelSubscriptionConfirmation: false
    };
  }
  componentDidMount() {
    this._getUserOrganization();
  }
  _getUserOrganization() {
    var self = this;
    return AppActions.getUserOrganization()
      .then(org => self.setState({ org: org }))
      .catch(err => console.log(`Error: ${err}`));
  }

  _copied() {
    var self = this;
    self.setState({ copied: true });
    setTimeout(() => {
      self.setState({ copied: false });
    }, 5000);
  }

  _cancelSubscriptionSubmit() {
    // if (this.props.cancelRequest) {
    //   this.props.cancelRequest(this.props.org.id, reason).then(() => this.setState({ cancelSubscription: false, cancelSubscriptionConfirmation: true }));
    // } else {
    //   console.log(this.state);
    // }
  }

  handleCancelSubscription(e) {
    if (e !== undefined) {
      e.preventDefault();
    }
    this.setState({ cancelSubscription: true });
  }

  render() {
    // const self = this;

    return (
      <div style={{ maxWidth: '750px' }} className="margin-top-small">
        <h2 style={{ marginTop: '15px' }}>My organization</h2>

        {this.state.org ? (
          <div>
            <List>
              <ListItem key="name" disabled={true}>
                <ListItemText primary="Tenant name" secondary={this.state.org.name} />
              </ListItem>
              <ListItem key="tenant-id" disabled={true}>
                <ListItemText primary="Tenant ID" secondary={this.state.org.id} />
              </ListItem>
              <ListItem key="organization" disabled={true}>
                <ListItemText primary="Organization" secondary={(this.state.org.tenant_info && this.state.org.tenant_info.organization || '-')} />
              </ListItem>
              <Divider />
              <div className="material-list-item">
                <h4 style={{ display: 'inline', paddingRight: '10px' }}>Token</h4>
                <div
                  id="token-info"
                  className="tooltip info"
                  data-tip
                  style={{ position: 'relative', display: 'inline', top: '6px' }}
                  data-for="token-help"
                  data-event="click focus"
                >
                  <InfoIcon />
                </div>
                <ReactTooltip id="token-help" globalEventOff="click" place="top" type="light" effect="solid" style={{}} className="react-tooltip">
                  <h3>Tenant token</h3>
                  <p style={{ color: '#DECFD9', margin: '1em 0' }}>
                    This token is unique for your organization and ensures that only devices that you own are able to connect to your account.
                  </p>
                  <p style={{ color: '#DECFD9', margin: '1em 0' }}>
                    Set this variable in <i>local.conf</i> in order to make the device recognize the organization to which it belongs.
                  </p>
                </ReactTooltip>

                <p style={{ wordBreak: 'break-all' }}>{this.state.org.tenant_token}</p>

                <CopyToClipboard text={this.state.org.tenant_token} onCopy={() => this._copied()}>
                  <Button style={{ marginTop: '15px' }} icon={<Icon className="material-icons">content_paste</Icon>}>
                    Copy to clipboard
                  </Button>
                </CopyToClipboard>

                <p style={{ marginLeft: '14px' }}>{this.state.copied ? <span className="green fadeIn">Copied to clipboard.</span> : null}</p>
              </div>
              <Divider />
            </List>
            <TenantInfo info={this.state.org.tenant_info || {}} />
            <Divider />
            {/* {this.state.cancelSubscriptionConfirmation ? (
              <Alert className="margin-top-large" severity="error" style={{ maxWidth: '500px' }}>
                <p>We&#39;ve started the process to cancel your plan and deactivate your account.</p>
                <p>
                  We&#39;ll send you an email confirming your deactivation. If you have any question at all, contact us at{' '}
                  <strong>
                    <a href="mailto:support@mender.io">support@mender.io</a>
                  </strong>
                </p>
              </Alert>
            ) : (
              <p className="margin-left-small margin-right-small">
                <Button variant='contained' onClick={e => self.handleCancelSubscription(e)} disabled>
                  End trial and deactivate account
                </Button>
              </p>
            )}
            {this.state.cancelSubscription && (
              <CancelRequestDialog onCancel={() => self.setState({ cancelSubscription: false })} onSubmit={value => this._cancelSubscriptionSubmit(value)} />
            )} */}
          </div>
        ) : null}
      </div>
    );
  }
}
